import React, { FC } from 'react';

interface ShareComponentProps {
  size?: number;
  round?: boolean;
}

export default function ShareIcon(Component: FC<ShareComponentProps>) {
  const WrappedComponent = () => <Component size={32} round={true} />;
  WrappedComponent.displayName = `ShareIcon(${
    Component.displayName || Component.name || 'Component'
  })`;
  return WrappedComponent;
}
